import React from "react";
import { Button } from "react-bootstrap";

// Ангиллын дэлгэцийн дээд toolbar. Одоогоор зөвхөн «Дахин ачаалах» товч.
// (Хуучин хайлтын debounce код ашиглагддаггүй байсан тул хассан.)
export default function CategoryToolbar({ onRefetch }) {
  return (
    <div className="page-title-box">
      <div className="page-title-right d-flex align-items-center mb-2 gap-2">
        <Button variant="primary" onClick={onRefetch}>
          <i className="mdi mdi-autorenew" />
        </Button>
      </div>
    </div>
  );
}
